import { up, down } from 'slide-element';
import announcer from './aria-announcer';

const $accordionWrappers = document.querySelectorAll('.accordion-wrapper');

$accordionWrappers.forEach(($wrapper) => {
    const $button = $wrapper.querySelector('.accordion-button');
    const $panel = $wrapper.querySelector('.accordion-panel');
    const $label = $button.querySelector('.label');

    $button.addEventListener('click', () => {
        const isExpanded = $button.getAttribute('aria-expanded') === 'true';

        $button.setAttribute('aria-expanded', !isExpanded);
        $panel.setAttribute('aria-hidden', isExpanded);

        const labelText = $label?.textContent?.trim() || '';

        if (!isExpanded) {
            down($panel);
            announcer.announce(`Le tirroir ${labelText} est ouvert`);
        } else {
            up($panel);
            announcer.announce(`Le tirroir ${labelText} est fermé`);
        }
    });
});
